import React from 'react';
import { useHistory } from 'react-router-dom';
import { CardHeader, Typography, IconButton } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DeviceIcon from '#component/icon/device-icon';
import Identifiers from '#component/device/overview/identifiers/identifiers';
import DeviceEvent from '#component/device/dashboard/event';
import { isActiveDevice } from '#component/device/helper';
import { DetailedCard, SingleItemRow, StyledDeviceIconWrapper, LabelText } from '#component/device/general/styles';

const UnfoldableCard = ({ device, account, loading, onOpenDrawer, meta, label }) => {
  const history = useHistory();
  const icon = meta.device?.find(m => m.name === device.type)?.icon;
  const isActive = isActiveDevice(device);

  return (
    <DetailedCard loading={loading}>
      <SingleItemRow>
        <CardHeader
          style={{ padding: 0 }}
          onClick={() => history.push(`/device/${device.id}`)}
          tabIndex={0}
          aria-label={`Edit project ${device.uid}`}
          subheader={
            <Typography>
              <StyledDeviceIconWrapper>
                <DeviceIcon icon={icon} isActive={isActive} />
              </StyledDeviceIconWrapper>
              {label || device.title || device.uid}
            </Typography>
          }
        />
        <IconButton
          size="small"
          onClick={e => {
            e.stopPropagation();
            onOpenDrawer(device.id);
          }}
        >
          <MoreHorizIcon />
        </IconButton>
      </SingleItemRow>
      <SingleItemRow>
        <LabelText>Type</LabelText>
        <Typography variant="h6">
          {device.type.charAt(0).toUpperCase() + device.type.slice(1)}
        </Typography>
      </SingleItemRow>
      <Identifiers
        device={device}
        account={account}
        loading={loading}
        lastMetric={device.lastMetric?.youngest}
      />
      {device.lastEvent &&
        <SingleItemRow>
          <LabelText>Event</LabelText>
          <Typography>
            <DeviceEvent device={device} account={account} loading={loading} align="end" />
          </Typography>
        </SingleItemRow>}
    </DetailedCard>
  );
};

export default UnfoldableCard;
